import React from 'react';
import { useCatalogHealth } from '../../lib/api/import';
import { ENGINE_COLORS as C, ENGINE_FONTS as F } from '../../components/engine/tokens';

export function CatalogHealthCard() {
  const { data, loading } = useCatalogHealth();

  if (loading || !data) return null;

  // Don't show the card if everything is healthy and no warnings
  if (data.overallHealth === 'Green' && data.warnings.length === 0) return null;

  return (
    <div style={cardStyle(data.overallHealth)}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <span style={dotStyle(data.overallHealth)} />
        <span style={{ fontFamily: F.mono, fontWeight: 600, fontSize: 13 }}>
          Catalog Health
        </span>
        <span style={{ fontFamily: F.mono, fontSize: 11, color: C.dim, marginLeft: 'auto' }}>
          {data.projectCount} projects, {data.workItemCount} work items
        </span>
      </div>

      {data.warnings.length > 0 && (
        <ul style={{ margin: '4px 0 0 0', padding: '0 0 0 18px', listStyle: 'disc' }}>
          {data.warnings.map((w, i) => (
            <li key={i} style={{ fontFamily: F.mono, fontSize: 11, color: C.text, marginBottom: 3, lineHeight: 1.4 }}>
              {w}
            </li>
          ))}
        </ul>
      )}

      {data.suggestedProjects.length > 0 && (
        <div style={{ marginTop: 10, borderTop: `1px solid ${C.dim}33`, paddingTop: 8 }}>
          <span style={{ fontFamily: F.mono, fontSize: 11, color: C.amber, fontWeight: 600 }}>
            Suggested projects (from unmatched conversations):
          </span>
          {data.suggestedProjects.map((s, i) => (
            <div key={i} style={suggestionStyle}>
              <span style={{ fontWeight: 600 }}>{s.suggestedName}</span>
              <span style={{ color: C.dim, marginLeft: 8 }}>
                ({s.conversationCount} unmatched conversations)
              </span>
            </div>
          ))}
        </div>
      )}

      {data.recentClassifiedCount > 0 && (
        <div style={{ marginTop: 8, fontFamily: F.mono, fontSize: 10, color: C.dim }}>
          Classification success rate: {Math.round(data.classificationSuccessRate * 100)}%
          ({data.recentClassifiedCount} recent)
          {' | '}
          Description coverage: {Math.round(data.descriptionCoverage * 100)}%
        </div>
      )}
    </div>
  );
}

function cardStyle(health: string): React.CSSProperties {
  const borderColor = health === 'Red' ? C.coral : health === 'Amber' ? C.amber : C.neon;
  return {
    background: `${C.surface}`,
    border: `1px solid ${borderColor}40`,
    borderLeft: `3px solid ${borderColor}`,
    borderRadius: 8,
    padding: '12px 16px',
    marginBottom: 16,
  };
}

function dotStyle(health: string): React.CSSProperties {
  const color = health === 'Red' ? C.coral : health === 'Amber' ? C.amber : C.neon;
  return {
    width: 8,
    height: 8,
    borderRadius: '50%',
    background: color,
    display: 'inline-block',
    flexShrink: 0,
  };
}

const suggestionStyle: React.CSSProperties = {
  fontFamily: F.mono,
  fontSize: 11,
  color: C.text,
  padding: '3px 0 3px 12px',
};
